export const recaptchaDisabledUrls = ["logindev.clearsale.com.br", "loginqa.clearsale.com.br", "localhost", "localhost.serasaexperian"]
export const isSerasa = window.location.href.includes("serasaexperian");
